import React from "react";
import StudentRow from "./StudentRow";
import "./Tables.css";

const GradesTable = ({ data }) => {
  const { labs = [], students = [] } = data;

  return (
    <div className="table-container">
      <div className="scrollable-table">
        <table className="main-table">
          <thead>
            <tr>
              <th className="table-th" style={{ minWidth: "220px" }}>Студент</th>
              {labs && labs.map((lab) => (
                <th key={lab.id} className="table-th">
                  ЛP №{lab.number}
                  <p>{lab.name}</p>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {students.map((entry) => (
              <StudentRow
                key={entry.student.id}
                student={entry.student}
                grades={entry.grades}
                labs={labs}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GradesTable;
